import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Section from "../components/base/Section.jsx";
import Input from "../components/base/Input.jsx";
import ConnexionCard from "../components/ConnexionCard.jsx";
import Form from "../components/base/Form.jsx";
import Select from "../components/base/Select.jsx";
import PhoneInput from "../components/base/PhoneInput.jsx";

const API_URL = process.env.REACT_APP_API_URL;

export default function SignupGoogle() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  const [formData, setFormData] = useState({
    firstname: searchParams.get("firstname") || "",
    lastname: searchParams.get("lastname") || "",
    email: searchParams.get("email") || "",
    phone: "",
    dateOfBirth: "",
    gender: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Vérifier qu'on a bien un email depuis Google
    if (!formData.email) {
      setError("Informations Google manquantes");
      setTimeout(() => navigate("/login"), 2000);
    }
  }, [formData.email, navigate]);

  const isFormValid = formData.firstname && formData.lastname && formData.dateOfBirth && formData.gender;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    console.log("Completing Google signup:", formData);

    try {
      const response = await fetch(`${API_URL}/auth/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          dateOfBirth: formData.dateOfBirth ? (formData.dateOfBirth instanceof Date ? formData.dateOfBirth.toISOString().split('T')[0] : formData.dateOfBirth) : null,
          password: null, // Pas de mot de passe pour OAuth
        }),
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.detail || "Erreur lors de la création du compte");
      }

      const data = await response.json();     
      localStorage.setItem("participant", JSON.stringify(data.participant));
      localStorage.setItem("user", JSON.stringify(data.user));

      navigate("/user", { replace: true });

    } catch (err) {
      setError(err.message || "Erreur lors de la création du compte");
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConnexionCard 
      brand="BIBbib" 
      title="Complétez votre profil" 
      subtitle="Quelques informations supplémentaires pour finaliser votre inscription"
      socials={false}
    >
      <Section title={null}>
        <Form onSubmit={handleSubmit} disabled={!isFormValid} >
          <div style={styles.info}>
            <p style={styles.infoText}>
              ✓ Connecté avec <strong>{formData.email}</strong>
            </p>
          </div>
          
          <div style={styles.row}>
            <Input label="Prénom" name="firstname" value={formData.firstname} setFormData={setFormData} type="text" />
            <Input label="Nom" name="lastname" value={formData.lastname} setFormData={setFormData} type="text" />
          </div>
          
          <PhoneInput label="Téléphone (optionnel)" name="phone" phoneValue={formData.phone} setFormData={setFormData} type="tel" />
          
          <div style={styles.row}>
            <Input 
              label="Date de naissance" 
              name="dateOfBirth" 
              type="date" 
              value={formData.dateOfBirth} 
              setFormData={setFormData} 
            />
            <Select 
              name="gender" 
              label="Genre" 
              dict={{ M: "Homme", F: "Femme", O: "Autre" }} 
              value={formData.gender} 
              setFormData={setFormData} 
            />
          </div>
          
          {error && <p style={styles.error}>{error}</p>}
        </Form>
      </Section>
    </ConnexionCard>
  );
}

const styles = {
  row: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 12,
    verticalAlign: "middle",
  },
  info: {
    background: "#f0fdf4",
    border: "1px solid #86efac",
    borderRadius: 6,
    padding: 12,
    marginBottom: 16,
  },
  infoText: {
    margin: 0,
    fontSize: 13,
    color: "#166534",
  },
  error: {
    color: "#b91c1c",
    fontSize: 13,
    margin: 0,
  },
};
